 //function to reorder result to ensure any key containing 'description' is last
    export default function reorder (arr: [], from: number, to: number) {
      const copy = [...arr];
      const [removed] = copy.splice(from, 1);
      copy.splice(to, 0, removed);
      return copy;
    };